import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// import { } from 'antd';

class Default extends Component {

	render() {
		return (
			<Fragment>
					{this.props.children}
			</Fragment>
		)
	}

}

export default connect()(Default);


// WEBPACK FOOTER //
// ./src/app/views/layouts/default.js